import type { LucideIcon } from "lucide-react";
import {
  Baby,
  Briefcase,
  Car,
  Cloud,
  Gift,
  HeartPulse,
  House,
  ReceiptText,
  ShoppingBasket,
  Utensils,
} from "lucide-react";

// One icon per kind of spending, matched on the category's name rather than an id, so a renamed
// or newly added category still gets a sensible glyph instead of falling back to a blank.

export const categoryIcon = (category: string): LucideIcon =>
  /dining|food/i.test(category)
    ? Utensils
    : /grocer/i.test(category)
      ? ShoppingBasket
      : /hous|rent/i.test(category)
        ? House
        : /health|toilet/i.test(category)
          ? HeartPulse
          : /transport|travel/i.test(category)
            ? Car
            : /subscr|util/i.test(category)
              ? Cloud
              : /family/i.test(category)
                ? Gift
                : /baby/i.test(category)
                  ? Baby
                  : /work/i.test(category)
                    ? Briefcase
                    : ReceiptText;

export default function CategoryIcon({
  category,
  size = 16,
  className,
}: {
  category: string;
  size?: number;
  className?: string;
}) {
  const Icon = categoryIcon(category);
  return <Icon size={size} className={className} />;
}
